import { PTI_STATUS_INACTIVE } from '@/consts/pti'

/**
 * Durée pour annuler l'alerte
 * @type {number}
 */
export const INACTIVITY_DETECTION_CANCEL = 10

/**
 * Notification préventive d'inactivité - Titre du modal
 * @type {string}
 */
export const INACTIVITY_NOTIFICATION_PREVENT_TITLE = 'Inactivité agent'

/**
 * Notification préventive d'inactivité - Message du modal
 * @type {string}
 */
export const INACTIVITY_NOTIFICATION_PREVENT_MESSAGE = 'Sans interaction de votre part, une alerte sera transmise.'

/**
 * Notification de transmission d'une inactivité - Message du modal
 * @type {string}
 */
export const INACTIVITY_NOTIFICATION_SEND_MESSAGE = 'Un signalement d\'inactivité agent à été transmis.'

/**
 * Notification de transmission d'une inactivité - Message secondaire du modal
 * @type {string}
 */
export const INACTIVITY_NOTIFICATION_SEND_CAPTION = 'Veuillez contacter votre agence au plus vite.'

/**
 * Seuil d'accélération pour une personne qui marche
 * @type {number} - Accélération
 */
export const INACTIVITY_DETECTION_SPEED_WALK = 2

/**
 * Différence entre deux dates pour la detection de marche
 * @type {number} - Différence
 */
export const INACTIVITY_WALK_DETECTION_DATE_DIFF = 1000

export const INACTIVITY_STATUS_INACTIVE = PTI_STATUS_INACTIVE
export const INACTIVITY_STATUS_ACTIVE = {
  value: 'active',
  label: 'Actif'
}
export const INACTIVITY_STATUS_INACTIVITY = {
  value: 'inactivity',
  label: 'Agent inactif'
}
export const INACTIVITY_STATUS_DESKTOP = {
  value: 'desktop',
  label: 'Cette fonctionnalité est indisponible sur un ordinateur'
}
export const INACTIVITY_STATUS_WALK = {
  value: 'walk',
  label: `L'agent marche`
}
export const INACTIVITY_STATUS_LIST = [
  INACTIVITY_STATUS_INACTIVE,
  INACTIVITY_STATUS_WALK,
  INACTIVITY_STATUS_ACTIVE,
  INACTIVITY_STATUS_INACTIVITY,
  INACTIVITY_STATUS_DESKTOP
]
